<div class="container">
  <div class="file-seletion-header">
    <div class="head-label">
      <span>{{ batch.name ? batch.name : (documentListHeader | translate) }}</span>
      <div class="document-options">
        <p-menu
          #menu
          [model]="menuOptions"
          [popup]="true"
          [appendTo]="'body'"
        >
        </p-menu>
        <p-button
          class="dap-menu-btn"
          aria-haspopup="true"
          icon="fa-regular fa-ellipsis"
          severity="contrast"
          variant="text"
          [tabindex]="disabled ? -1 : 0"
          [ariaLabel]="'documentListOptions' | translate"
          (click)="menu.toggle($event)"
        >
        </p-button>
      </div>
    </div>
  </div>
  <div class="files-container">
    @if (attachments.length === 0 && !isLoadingFiles) {
      <span class="no-attachments-label">{{ 'noDocumentsToSelect' | translate }}</span>
    }
    @for (file of attachments; track file.id; let i = $index) {
      <div class="file-option-container">
        @if (file?.canceled !== true) {
          <div
            class="dap-select-document file-option"
            role="button"
            [class.expiration-bg-warning]="isExpiringSoon(file.expirationDate)"
            [tabindex]="disabled ? -1 : 0"
            [ngClass]="{
              'active-file':
                selectedDocumentId === file.id ||
                (!selectedDocumentId && currentAttachmentIndex === i)
            }"
            [attr.aria-label]="file.name + (file.completed ? ' (Completed)' : '')"
            [attr.aria-selected]="
              selectedDocumentId === file.id ||
              (!selectedDocumentId && currentAttachmentIndex === i)
            "
            (click)="selectAttachment(i)"
            (keyup.enter)="selectAttachment(i)"
            (keydown.space)="selectAttachment(i)"
          >
            <span
              #labelRef
              class="file-label"
              tooltipPosition="right"
              showDelay="500"
              hideDelay="300"
              [pTooltip]="file.name"
              [tooltipDisabled]="!isTextOverflowing(labelRef)"
            >
              {{ file.name }}
            </span>
            <div class="file-status-icons">
              @if (docExpirationUiEnabled() && file.isExpired) {
                <i
                  class="fa-solid fa-triangle-exclamation expired"
                  aria-hidden="true"
                  tooltipPosition="top"
                  showDelay="500"
                  [pTooltip]="'documentExpired' | translate"
                ></i>
              } @else if (docExpirationUiEnabled()) {
                <app-document-expiration-warning [expirationDate]="file.expirationDate" />
              }
              <!-- Completion Checkmark  -->
              @if (file.completed) {
                <i
                  class="fa-solid fa-circle-check check"
                  aria-hidden="true"
                ></i>
                <span class="sr-only">Completed</span>
              }
              <!-- Loading Spinner -->
              @if (!file.status && file.classificationStarted && isAutoClassificationEnabled) {
                <div
                  class="spinner-container"
                  aria-live="polite"
                  aria-busy="true"
                >
                  <ngx-spinner
                    color="#006CFA"
                    bdColor="rgba(255,255,255, 0.3)"
                    type="ball-spin-clockwise"
                    size="small"
                    [fullScreen]="false"
                    [name]="'fileClassificationSpinner-' + file.name"
                  ></ngx-spinner>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
  @if (enableBatchOptions) {
    <div class="close-batch-container">
      <p-button
        label="{{ 'closeBatch' | translate }}"
        class="dap-close-batch close-batch-button"
        variant="text"
        [tabindex]="disabled ? -1 : 0"
        [attr.aria-label]="'closeBatch' | translate"
        (click)="closeBatch()"
      >
      </p-button>
    </div>
  } @else {
    <div class="close-batch-container">
      <p-button
        label="{{ 'closeDocuments' | translate }}"
        class="dap-close-documents close-batch-button"
        variant="text"
        [tabindex]="disabled ? -1 : 0"
        [attr.aria-label]="'closeDocuments' | translate"
        (click)="showCloseDocumentsDialog = true"
      >
      </p-button>
    </div>
  }
</div>

<p-dialog
  class="p-dialog-source"
  [header]="'closeDocumentsDialog' | translate"
  [modal]="true"
  [closable]="true"
  [resizable]="false"
  [(visible)]="showCloseDocumentsDialog"
  (onHide)="showCloseDocumentsDialog = false"
>
  <p class="dialog-content">{{ 'closeDocumentsConfirmation' | translate }}</p>
  <div class="dialog-footer">
    <p-button
      class="dap-cancel-close"
      variant="text"
      [label]="'cancel' | translate"
      (onClick)="showCloseDocumentsDialog = false"
    >
    </p-button>
    <p-button
      class="dap-confirm-close"
      severity="secondary"
      [label]="'closeDocuments' | translate"
      (onClick)="closeDocuments()"
    >
    </p-button>
  </div>
</p-dialog>
